exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#proposal-settings-template-manage-div {\n  padding: 5px 0;\n  box-shadow: 0px 8px 16px rgba(0, 0, 0, .15);\n  background-color: #fff;\n  min-height: 80vh;\n  border-radius: 5px;\n}\n#proposal-settings-template-manage-div h5 {\n  color: #222;\n  font-weight: 400;\n  padding: 5px 0px;\n}\n#proposal-settings-template-manage-div .add-new-template-button {\n  height: 40px;\n  font-weight: 300;\n}\n", ""]);

// exports
